var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMongodb = function SvgMongodb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mongodb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#023430",
    d: "M12.624.037h-8.5a3.75 3.75 0 0 0-3.75 3.75v8.5a3.75 3.75 0 0 0 3.75 3.75h8.5a3.75 3.75 0 0 0 3.75-3.75v-8.5a3.75 3.75 0 0 0-3.75-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10AA50",
    d: "M11.072 6.761c-.659-2.905-2.031-3.678-2.381-4.225a6 6 0 0 1-.383-.749c-.019.258-.053.42-.272.616-.44.393-2.311 1.917-2.468 5.218-.147 3.078 2.262 4.976 2.58 5.172.245.12.543.002.689-.108 1.16-.797 2.748-2.922 2.236-5.924"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C4C2",
    d: "M8.408 11.154c-.06.762-.104 1.204-.258 1.64 0 0 .1.725.172 1.493h.25q.09-.812.275-1.608c-.325-.16-.427-.857-.44-1.525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12924F",
    d: "M8.846 12.68c-.328-.153-.423-.864-.438-1.526q.122-1.64.071-3.284c-.017-.575.008-5.323-.141-6.018q.153.354.353.684c.35.547 1.723 1.32 2.381 4.225.513 2.997-1.065 5.116-2.226 5.918"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mongodb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.374.037h16v16h-16z"
  })))));
};
export default SvgMongodb;